export default __webpack_public_path__ + "static/media/icon_hide_password.61ca9aeb.svg";